
import { defineComponent, ref, onBeforeMount, onMounted } from "vue";
import { MetaInfo } from "vue-meta";
import EventList from "./index/EventList.vue";
import ValueProposition from "./index/ValueProposition.vue";
import EventsEmptyState from "@components/events/EmptyState.vue";
import { alternateService } from "@services/alternate.service";
import { apiService } from "@services/api.service";
import { ciTrackingService } from "@services/ci-tracking.service";
import { CurrentUser } from "@utils/user";

export default defineComponent({
  name: "CiSocialEventsIndex",
  components: {
    "events-empty-state": EventsEmptyState,
    "event-list": EventList,
    "value-proposition": ValueProposition,
  },

  metaInfo(): MetaInfo {
    const title = this.$t("ui.views.social_events.index.meta_tags.title") as string;
    const description = this.$t("ui.views.social_events.index.meta_tags.description") as string;
    return {
      title: title,
      link: alternateService.fromRoute(this.$route),
      meta: [
        { vmid: "description", name: "description", content: description },
        { vmid: "og:title", property: "og:title", content: title },
        { vmid: "og:description", property: "og:description", content: description },
        { vmid: "twitter:title", name: "twitter:title", content: title },
        { vmid: "twitter:description", name: "twitter:description", content: description },
      ],
    };
  },

  setup() {
    const events = ref<Events.Event[]>([]);
    const state = ref<"loading" | "success" | "error" | null>(null);

    onBeforeMount(() => {
      if (CurrentUser.signedIn) {
        fetchEvents();
      }
    });

    onMounted(async () => {
      await ciTrackingService.trackView("EventOverview");
    });

    async function fetchEvents(): Promise<void> {
      try {
        const response = await apiService.social_events.index();
        state.value = "success";
        events.value = response.data.social_events;
      } catch (err) {
        state.value = "error";
        apiService.handleAPIError(err);
      }
    }

    return {
      CurrentUser,
      events,
      state,
    };
  },
});
